import { render, staticRenderFns } from "./AWDocAuthentication.vue?vue&type=template&id=5ebe2a9f&scoped=true&"
import script from "./AWDocAuthentication.vue?vue&type=script&lang=js&"
export * from "./AWDocAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./AWDocAuthentication.vue?vue&type=style&index=0&id=5ebe2a9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe2a9f",
  null
  
)

export default component.exports